import { Component, NgZone, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-item-history-bought',
  templateUrl: './item-history-bought.component.html',
  styleUrls: ['./item-history-bought.component.css']
})
export class ItemHistoryBoughtComponent implements OnInit {
  private sub: Subscription;
  mainLoader;
  user_id;
  itemHistory;
  historyLength;
  loading = false;
  pageSize = 10;
  pageNo = 1;
  allCategories;
  categoryId = 0;
  userAccessToken: string;
  transaction_id: string;
  payoutItemId: string;
  buyId: string;
  itemId: string;
  amount: string;
  requestid: string;
  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private http: Http,
    private route: ActivatedRoute,
  ) {
    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
    }
    if (localStorage.getItem('currentMenu')) {
      localStorage.removeItem('currentMenu');
      localStorage.setItem('currentMenu', 'history');
    }
  }
  async ngOnInit() {
    await this.getUserAccessToken();
    await this.getUserInfo();
    // await this.finalPaymentSuccessApi();
    await this.finalPaymentSuccess();
    window.scrollTo(0, 0);
    this.mainLoader = '../../assets/images/BigLoader.gif';
    await this._itemHistory();

    // Assuming advtService.getAllCategories() returns a Promise
    const data = await this.advtService.getAllCategories().toPromise();
    this.allCategories = data;
  }

  getUserAccessToken() {
    const currentUserToken = JSON.parse(localStorage.getItem("currentUser"));
    this.userAccessToken = currentUserToken.access_token;
  }
  getUserInfo() {
    const urlParams = new URLSearchParams(window.location.search);
    const buyerId = urlParams.get('buyId')
    const itemId = urlParams.get('itemId')
    this.transaction_id = localStorage.getItem(`${buyerId}${itemId}_tid`);
    this.payoutItemId = localStorage.getItem(`${buyerId}${itemId}_pid`);
    this.requestid = localStorage.getItem(`${buyerId}${itemId}_req`)
    ///////
    this.buyId = this.route.snapshot.queryParamMap.get('buyId');
    this.itemId = this.route.snapshot.queryParamMap.get('itemId');
    this.amount = this.route.snapshot.queryParamMap.get('amount');
    // this.requestid = this.route.snapshot.queryParamMap.get('reqtID')
  }

  finalPaymentSuccess() {
    let input;

    if (this.requestid !== null) {
      input = {
        amount: `${this.amount}`,
        buyer_id: `${this.buyId}`,
        item_id: `${this.itemId}`,
        order_id: `${this.transaction_id}`,
        request_id: `${this.requestid}`,
        status: 'succeeded',
        transfer_id: this.payoutItemId,
        type: 0,
      };
    } else {
      input = {
        amount: this.amount,
        buyer_id: `${this.buyId}`,
        item_id: `${this.itemId}`,
        order_id: `${this.transaction_id}`,
        status: 'succeeded',
        transfer_id: this.payoutItemId,
        type: 1,
      };
    }
    this.advtService.getPaymentToken(this.userAccessToken, input).subscribe(
      (res: any) => {
      },
      (error: any) => {
      }
    );
  }

  public _itemHistory() {
    this.loading = true;
    var params = {
      user_id: this.user_id,
      limit: this.pageSize,
      offset: 0,
      user_type: 'buyer',
      category_id: this.categoryId
    };
    this.advtService.itemHistory(params).subscribe((data) => {
      this.itemHistory = data.result;
      this.historyLength = data.count;
      this.loading = false;
    });
  }
  /**
* This function is used for pagination
* @param data
*/
  pagingAgent(data, user_id) {
    this.loading = true;
    this.itemHistory = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;
    var params = {
      user_id: this.user_id,
      limit: this.pageSize,
      offset: this.pageNo,
      user_type: 'buyer',
      category_id: this.categoryId
    };
    this.itemHistory = [];
    this.advtService.itemHistory(params).subscribe((data) => {
      window.scrollTo(0, 0);
      this.itemHistory = data.result;
      this.loading = false;
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/authorized-data/item-history-bought/item-history-bought.component.ts